const variables = {
    API_URL: process.env.VUE_APP_AXIOS_BASE_URL,
    //https://localhost:44388/api/values
    //process.env.VUE_APP_AXIOS_BASE_URL
  };
  
  export default variables;
  